<template>
  <div class="block-yougot">
    <bimContainer>
      <bim-text adaptive bold type=h4 class="text-center">Вы получите</bim-text>
      <bim-text adaptive type=accent class="text-center mt-11 mb-10">Таблицу конъюнктурного анализа с обоснованиями</bim-text>
      <img alt="" :src="img_catalog + 'special-table.svg'" />
    </bimContainer>
  </div>
</template>

<script>
import bimContainer from "@bimlib/components/bimContainer"
import bimCol from "@bimlib/components/bimCol"
const img_catalog = "/dist/assets/front_white/img/landing_estimate/"
export default {
  name: "",
  components: {
    bimContainer,
    bimCol,
  },
  data() {
    return {
      img_catalog,
    }
  }
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/settings";
.text-center {
  text-align: center;
}
.block-yougot {
  padding: 64px 0 41px;
}
</style>
